import { ShortObject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-json-object';
import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortProject } from 'projects/app-misc/src/app/modules/project-misc/data/project/short-project';

@JsonObject('model.orderFilters')
export class OrderFilters extends AbstractModel {

	@JsonProperty([ShortProject], 'projects')
	projects: ShortProject[];

	@JsonProperty([ShortObject], 'statuses')
  statuses: ShortObject[];

  @JsonProperty([ShortObject], 'vendors')
  vendors: ShortObject[];

}
